/**
 * 
 * Container Box
 * 
 */

import React from 'react';
import { ImplementationFor } from '../../utility';



const Inputs = ({ field, metaData, onInputChange }) => {
    const Component = ImplementationFor[field.fieldType] || false;
    return Component && <Component
        {...field}
        name={field.fieldName}
        label={field.fieldDescription}
        placeholder={field.fieldDescription}
        onInputChange={onInputChange}
        metaData={metaData}
        noLabel={true}
    /> || null;

}

class ContainerBox extends React.Component {


    render() {
        const { name, label, onInputChange, containers, submitData } = this.props;
        const fields = containers && Object.keys(containers).length > 0 && Object.keys(containers).find(key => key === name) || false;
        return containers && containers[fields] && containers[fields].length > 0 &&
            <div className="p-col-12">
                <h1>{label}</h1>
                <div className="p-grid">
                    {containers[fields].map((subField, subFieldIndex) => 
                    <div key={subFieldIndex} className="p-col-12 p-md-6 p-lg-3">
                        <Inputs
                            field={Object.assign({}, { ...subField }, { value: submitData[subField.fieldName] || subField.fieldValue || '' })}
                            onInputChange={onInputChange}
                            metaData={this.props.metaData} />
                    </div>)}
                </div>
            </div> || null
    }
}


export default ContainerBox;